import React from 'react'
import PropTypes from 'prop-types'

import { Switch as SwitchComponent } from '@mui/material'
import colors from '@settings/styleSettings'

const Switch = ({ checked, onChange, ...props }) => {
  return (
    <SwitchComponent
      checked={checked}
      onChange={onChange}
      color={window.location.href.includes('cynthia-charone') ? 'error' : 'primary'}
      sx={{
        '&.MuiSwitch-root .MuiSwitch-switchBase': {
          color: colors.primary,
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: colors.primary,
        },
        '&.MuiSwitch-root .Mui-checked': {
          color: colors.primary
        }
      }}
      {...props}
    />
  )
}

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

Switch.defaultProps = {
  checked: false,
  onChange: () => {},
}

export default Switch
